/*
 * @Autor: xx
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2020-05-26 18:18:21
 */

import { request } from "./api-require";

const API_URL = "/basic-operate-log/v1";

export const getOperateLog = (data = {}, config = {}) => {
  return request(API_URL + "/operateLog/page", data, config);
};
export const getOperateLoginLog = (data = {}, config = {}) => {
  return request(API_URL + "/log/login/page", data, config);
};
